<template>
  <BreadCrumb :PageTitle="t('breadCrumb.multipleTransfer')" />
  <MassTransfertsContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MassTransfertsContent from "../../components/CRM/Leads/MassTransfertsContent.vue";


export default defineComponent({
  name: "MassTransfertsPage",
  components: {
    BreadCrumb,
    MassTransfertsContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>